import React from 'react';
import '../components/css/popupstyle.css';
import $ from 'jquery';
import loader from '../../src/components/css/dark/img/loader.gif';

class Confirm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            password: '',
            cpassword: '',
            btnClick: false,
            btnClick2: false,
            UserName: this.props.UserName,
            UserEmail: this.props.UserEmail,
            UserId: this.props.UserId
        };

    }
    componentDidMount() {

    }
    componentDidUpdate() {

    }

    render() {
        return (

            <div className='tool-section report confirmClose edit'>
                <div className='popup report-section'>
                    <div className='popup_inner confirm-text'>
                        <h1>{this.props.titleText}</h1>
                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.</p>
                        {
                            this.props.ConfirmSection == true ?
                                <div className="pop-btn">
                                    <button className="btn" onClick={this.props.handleEditUser}>Yes</button>
                                    <button className="btn cancel" onClick={this.props.CloseConfirmPopup}>No</button>
                                </div> : null
                        }
                    </div>
                </div>
            </div>

        )
    }
}

export default Confirm;